<template>
  <a-layout-sider>
    <div class="logo" />
    <a-affix :offset-top="0">
      <a-menu theme="dark" @click="handleMenuClick" :default-open-keys="currentOpenKey"
        :default-selected-keys="currentMenuKey" mode="inline">
        <a-menu-item key="home">
          <a-icon type="user" />
          <span class="nav-text">系统主页</span>
        </a-menu-item>
        <a-sub-menu key="sub5">
          <!-- <span slot="title"><a-icon type="reconciliation" /><span>会员卡管理</span></span> -->
          <span slot="title"><a-icon type="reconciliation" /><span>渠道分销管理</span></span>
          <a-menu-item key="discountCode">渠道分销码管理</a-menu-item>
          <a-menu-item key="cardList">实体卡管理</a-menu-item>
        </a-sub-menu>
<!--        <a-sub-menu key="sub1">-->
<!--          <span slot="title"><a-icon type="team" /><span>职员信息</span></span>-->
<!--          <a-menu-item key="staff">职员管理</a-menu-item>-->
<!--          <a-menu-item key="import">批量导入</a-menu-item>-->
<!--        </a-sub-menu>-->
        <a-sub-menu key="sub4">
          <span slot="title"><a-icon type="reconciliation" /><span>会员管理</span></span>
          <a-menu-item key="inviteStatistics">企业会员</a-menu-item>
          <a-menu-item key="firstStaff">会员汇总</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub3">
          <span slot="title"><a-icon type="reconciliation" /><span>企业信息</span></span>
          <a-menu-item key="profile">企业档案</a-menu-item>
        </a-sub-menu>
        <a-sub-menu key="sub2">
          <span slot="title"><a-icon type="pay-circle" /><span>资金信息</span></span>
          <a-menu-item key="balance">资金管理</a-menu-item>
        </a-sub-menu>

        <!-- <a-sub-menu key="sub6">
          <span slot="title"><a-icon type="reconciliation" /><span>实体卡管理</span></span>
          <a-menu-item key="cardList">关联实体卡列表</a-menu-item>
        </a-sub-menu> -->
      </a-menu></a-affix>
  </a-layout-sider>
</template>

<script>
export default {
  name: "HinaBaseSlider",
  props: {
    currentMenuKey: {
      type: Array,
      default: () => ["home"],
    },
    currentOpenKey: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleMenuClick: function (e) {
      // console.log(e.key)
      this.$router.push({
        path: e.key,
      });
    },
  },
  mounted: function () {
    // console.log(this.currentMenuKey, '组件内当前菜单')
    // console.log(this.currentOpenKey, '组件内展开菜单')
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 64px;
  // background: rgba(255, 255, 255, 0.2);
  margin: 0;
}

// .ant-menu-inline{
// 	.ant-menu-submenu{
// 		.ant-menu-submenu-title{ font-size: 16px; }
// 	}
// }
.ant-menu-inline {
  .ant-menu-item:first-of-type {
    margin-top: 0;
  }
}

// .ant-menu-item{
// 	.anticon{ font-size: 18px; max-width: 18px;}
// }
// .ant-menu-submenu-title{
// 	.anticon{ font-size: 18px; max-width: 18px;}
// }
</style>